import(/* webpackMode: "eager", webpackExports: ["UserSignUpFormWrapper"] */ "/vercel/path0/components/auth/sign-up-form-wrapper.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
